import { ChipsRow, StyledChip } from './shared.styles';

function Chips({ options, value, onSelect }) {
  return (
    <ChipsRow>
      {options.map(option => (
        <StyledChip key={option} type="button" $active={value === option} onClick={() => onSelect(option)}>
          {option}
        </StyledChip>
      ))}
    </ChipsRow>
  );
}

export default Chips;
